import script from "./ImageTextCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageTextCard.vue?vue&type=script&setup=true&lang=js"

import "./ImageTextCard.vue?vue&type=style&index=0&id=45df1dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45df1dec"]])

export default __exports__